<template>
  <div class="password-login-form">
    <div class="intro-section__headline">
      <h4 class="intro-section__headline__txt">
          <span>
          {{ $t('pages.login.headline_txt') }}
          <router-link :to="{ name: 'signup' }" exact class="text-primary">
            {{ $t('forms.login_form.create_account_btn') }}
          </router-link>
        </span>
      </h4>

    </div>
    <div class="form-alert-errors" v-if="serverErrors && serverErrors.length > 0">
      <ul class="list-unstyled m-0">
        <li v-for="(error, i) in serverErrors" :key="i">{{ error }}</li>
      </ul>
    </div>

    <form @submit.prevent="handleLogin" class="intro-section__form">
      <div class="form-group">
        <input
            type="email"
            v-model="email"
            required
            class="input form-control"
            :placeholder="$t('forms.login_form.email')"
            :disabled="loading"
        />
      </div>

      <div class="form-group">
        <input-password
            v-model="password"
            :required="true"
            :placeholder="$t('forms.login_form.password')"
            :disabled="loading"
        />
      </div>

      <div class="form-group m-0">
        <button type="submit" class="btn btn-primary m-0 w-100" :disabled="loading">
          <span v-if="!loading">{{ $t('forms.login_form.login_btn') }}</span>
          <span v-else>{{ $t('forms.login_form.logging_in') }}</span>
        </button>
      </div>

      <div class="form-group text-center mb-0 mt-3">
        <router-link :to="{ name: 'reset-password' }">
          {{ $t('forms.login_form.forgot_password_btn') }}
        </router-link>
      </div>
    </form>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import InputPassword from '@/components/InputPassword'

export default {
  name: 'PasswordLoginForm',

  components: {
    InputPassword
  },

  data() {
    return {
      email: '',
      password: '',
      serverErrors: [],
      loading: false
    }
  },

  methods: {
    ...mapActions('auth', ['authenticate']),

    async handleLogin() {
      this.serverErrors = []
      this.loading = true

      try {
        await this.authenticate({
          method: 'password',
          credentials: {
            email: this.email,
            password: this.password
          },
          remember: true
        })

        this.$emit('success')
      } catch (error) {
        console.error('Password login error:', error)
        this.serverErrors = (error.response && error.response.data && error.response.data.non_field_errors) ||
            [this.$t('forms.login_form.error_generic')]
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.password-login-form {
  width: 100%;
}

.form-alert-errors {
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 16px;
  color: #721c24;
}
</style>
